// extracted by css-extract-rspack-plugin
export default {"root":"NotificationLayout_root__m7-sV","unread":"NotificationLayout_unread__giWIW"};